import axios from "./axios-handler.service";
const BASE_URL = "/api/FilaMensagens";

export interface FilaMensagem {
  idFilaMensagem: string;
  idConsultor: number;
  mensagem: string;
  data: string;
  tipoMensagem: number;
}

export class FilaMensagensService {
  static async ListarFilaMensagemConsultor(
    idConsultor: number | null
  ): Promise<FilaMensagem[]> {
    const response = await axios.get<FilaMensagem[]>(
      `${BASE_URL}/ListarFilaMensagemConsultor`,
      {
        params: { idConsultor },
      }
    );
    return response.data;
  }

  static async Obter(
    idConsultor: number,
    idFilaMensagem: string
  ): Promise<FilaMensagem> {
    const response = await axios.get<FilaMensagem>(
      `${BASE_URL}/Obter`,
      {
        params: { idConsultor, idFilaMensagem },
      }
    );
    return response.data;
  }
}
